@if (billingAreaPartnersWidgetData && initialized) {
    <mvs-widget [widgetData]="billingAreaPartnersWidgetData"></mvs-widget>
}
